import { useEffect, useRef } from 'react'

export default function TopScrollTable({
  children
}: {
  children: React.ReactNode
}) {
  const topScrollRef = useRef<HTMLDivElement | null>(null)
  const tableScrollRef = useRef<HTMLDivElement | null>(null)
  const tableRef = useRef<HTMLDivElement | null>(null)
  const topInnerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const topEl = topScrollRef.current
    const tableEl = tableScrollRef.current
    const table = tableRef.current
    const topInner = topInnerRef.current

    if (!topEl || !tableEl || !table || !topInner) return

    topInner.style.width = table.scrollWidth + 'px'

    const syncTop = () => {
      tableEl.scrollLeft = topEl.scrollLeft
    }
    const syncBottom = () => {
      topEl.scrollLeft = tableEl.scrollLeft
    }

    topEl.addEventListener('scroll', syncTop)
    tableEl.addEventListener('scroll', syncBottom)

    return () => {
      topEl.removeEventListener('scroll', syncTop)
      tableEl.removeEventListener('scroll', syncBottom)
    }
  }, [])

  return (
    <div className="w-full">
      {/* Scroll u góry */}
      <div ref={topScrollRef} className="overflow-x-auto overflow-y-hidden h-4">
        <div ref={topInnerRef} className="h-px"></div>
      </div>

      {/* Właściwy scroll z tabelą */}
      <div
        ref={tableScrollRef}
        className="overflow-x-auto overflow-y-hidden border border-gray-300"
      >
        <div ref={tableRef}>{children}</div>
      </div>
    </div>
  )
}
